import { render, staticRenderFns } from "./GuestLayoutComponent.vue?vue&type=template&id=66ae2dd5&"
import script from "./GuestLayoutComponent.vue?vue&type=script&lang=ts&"
export * from "./GuestLayoutComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports